import {
    Component,
    OnDestroy,
    OnInit,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { TabComponent } from "@components/tabs/tab/tab.component";
import { TabsComponent } from "@components/tabs/tabs.component";
import { cloneDeep } from "lodash";
import { Subject } from "rxjs";
import { take, takeUntil } from "rxjs/operators";
import { ModalSettings } from "~app/common/components/modal/modal-models";
import { RaskModalService } from "~app/common/components/modal/rask-modal.service";
import { ITab } from "~app/common/components/tabs/tab/itab";
import { ConfirmDialogResponse } from "~app/common/models/constants";
import { IVKNamedSearchFilter } from "../../models/kontrakt-search-filter-model";
import { AnbudKontraktSearchService } from "../../services/anbud-kontrakt-search.service";
import { KontraktSearchMinaFilterService } from "./kontrakt-search-mina-filter.service";

@Component({
    selector: "rask-kontrakt-search-mina-filter",
    templateUrl: "./kontrakt-search-mina-filter.component.html",
    styleUrls: ["./kontrakt-search-mina-filter.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TabsComponent,
        TabComponent
    ]
})
export class KontraktSearchMinaFilterComponent implements OnInit, OnDestroy {
    protected sokningar: IVKNamedSearchFilter[];

    private readonly $unsubscribe: Subject<void> = new Subject();
    private readonly anbudKontraktSearchService = inject(AnbudKontraktSearchService);
    private readonly kontraktMinaFilterService = inject(KontraktSearchMinaFilterService);
    private readonly modalService = inject(RaskModalService);

    confirmDeleteSparadSokning(tab: ITab) {
        this.modalService.confirm(new ModalSettings("Ta bort sökning", `Är du säker på att du vill ta bort "${tab.label}"`))
            .pipe(take(1))
            .subscribe((ok) => {
                if (ok === ConfirmDialogResponse.save && this.sokningar.find(x => x.namn === tab.label)) {
                    this.kontraktMinaFilterService.deleteSearchFilterByNamn(tab.label);
                }
            });
    }

    ngOnDestroy(): void {
        this.$unsubscribe.next();
        this.$unsubscribe.complete();
    }

    ngOnInit(): void {
        this.kontraktMinaFilterService.minaSparadeFilter
            .pipe(takeUntil(this.$unsubscribe))
            .subscribe(x => {
                this.sokningar = Object.assign([], x);
            });
    }

    setSokning(sparadSokningNamn: IVKNamedSearchFilter) {
        if (sparadSokningNamn) {
            const kopia = cloneDeep(sparadSokningNamn);
            this.anbudKontraktSearchService.applyFilter(kopia.filter);
        }
    }
}
